import { Flex, Text, DescriptionOutlinedIcon } from '@shared/components';

export default function QuestionListNoRowOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        py: theme.spacing(4),
        gap: theme.spacing(4),
        flexDirection: 'column',
        alignItems: 'center',
      })}
    >
      <DescriptionOutlinedIcon
        sx={(theme) => ({ fontSize: '48px', color: theme.palette.grey[400] })}
      />
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2), alignItems: 'center' })}
      >
        <Text variant='h5'>ยังไม่มีคำถาม</Text>
        <Text variant='body2' sx={(theme) => ({ color: theme.palette.text.secondary })}>
          เลือกคลังข้อสอบและคลิก &quot;+ Add Question&quot; เพื่อเพิ่มคำถามที่ต้องการทบทวน
        </Text>
      </Flex>
    </Flex>
  );
}
